module.exports = __webpack_public_path__ + "static/media/idms_dashboard.12551080.PNG";